import { render, staticRenderFns } from "./UiYoutubePlayer.vue?vue&type=template&id=75f7765f&lang=pug"
import script from "./UiYoutubePlayer.vue?vue&type=script&lang=js"
export * from "./UiYoutubePlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports